export default __webpack_public_path__ + "static/media/biodegradable-raw-icon.a9adc3a2.svg";